import { useCallback } from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import ConnectButton from '../components/connect-button';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useNavigate, useLocation, useParams, Link } from 'react-router-dom';
import A from '@mui/material/Link';
import NFTVideo from '../components/nft2026';
import { T, P } from '../components/Typography';
import theme from '../theme';
import { observer } from 'mobx-react-lite';
import { NFT2026ID, DROP_2026_OVER_AT, WL_2026_SHEET } from '../constants.js';
import { countdown } from '../state/index';

const D = () => <Divider sx={{ m: 4, mb: 4 }} />;

function NFT({ NFT} ) {
  const navigate = useNavigate();
  const location = useLocation();

  const goBuy = useCallback(() => {
    navigate('/nft/2026/buy');
  }, [navigate]);

  const viewInNFTExplorer = useCallback(() => {
    const url = `https://explorer.perawallet.app/asset/${NFT2026ID}`;
    if (!window.open(url))
      location.href = url;
  }, [NFT2026ID]);

  // After the June 12, 2026 claim window closes there's nothing left to claim,
  // so drop the eligibility/connect-wallet copy and just point at the whitelist.
  const nowSec = countdown.serverNow ?? Math.floor(Date.now() / 1000);
  const dropOver = nowSec >= DROP_2026_OVER_AT;

  return <Box>
    <Typography align="center" variant="h1" color="primary" sx={{ mb: 3 }}>2026 Algorand Birthday NFT</Typography>
    <Box sx={{overflow: 'hidden', maxWidth: '95vw' }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3, mb: 3, overflow: 'hidden' }}>
        <NFTVideo />
      </Box>
    </Box>
    <T>This NFT celebrates Algorand MainNet's <P>7 years </P>of fast & stable operation since Block Zero. In the animation, the Algorand logo rotates and reconfigures itself to show the roman numeral <P>VII</P> for 7.</T>
    <T>It is a fractional NFT with up to <P>777 copies</P> available during June 12, 2026. 40 of these are reserved and the other 737 are available to be claimed. Any NFTs not claimed or sold on June 12th, 2026 (UTC) will be burned.</T>
    <T>It is minted with the special occasion address <A href="https://explorer.perawallet.app/address/JUNEIIT5R6752NA33UHEVQ5AL6GK4WZ5M6DJGJGVZO6V4ETUFIDOVBCAME/">JUNEII..CAME</A>. All future NFTs will be minted with the same address.</T>
    {dropOver ? (
      <T>The 2026 birthday drop has ended. Eligible wallets are listed in <A href={WL_2026_SHEET} target="_blank">this spreadsheet</A>.</T>
    ) : (
      <>
        <T><P>This year the birthday NFT can not be purchased.</P> Instead, it can be claimed for free by:</T>
        <T>1) Anyone who attends the June 12th midnight countdown<br/>2) Anyone who has ever claimed or bought an NFT from this site in the past.</T>
        <T>You can check your eligibility by connecting your wallet, or by consulting <A href={WL_2026_SHEET} target="_blank">this spreadsheet</A>.</T>
      </>
    )}
    <D />
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'column', md: 'row' }, justifyContent: 'center' }}>
        <Button onClick={goBuy} variant="contained">Check Availability</Button>
        <Box sx={{ width: 10, height: 10}} >&nbsp;</Box>
        <Button onClick={viewInNFTExplorer} variant="outlined">View on Pera Explorer</Button>
      </Box>
    </Box>
    <D />
    <T>The NFT is recognized as a collectible on the Pera NFT Wallet and the video displays properly on both Android and iOS. The encoding used is common enough to be supported by Pera, as well as future NFT wallets, for years to come. The video file is stored immutably on IPFS.</T>
    {!dropOver && <T>If you were present on this website with a connected wallet on June 12, 2026, 00:00 UTC, your browser received a code that makes you eligible for a free copy of the NFT.</T>}
  </Box>;
}

export default observer(NFT);
